import { BubblesIcon, BulbIcon, FountainIcon, LanternIcon } from "./Icons";

// Appareils pilotés par interrupteur (mêmes identifiants Home Assistant qu'avant)
export const ALL_DEVICES = [
  { label: "Salon", id: "switch.sonoff_10009528c3", type: "light", visKey: "salon" },
  { label: "Chambre", id: "switch.sonoff_1000953411", type: "light", visKey: "chambre" },
  { label: "Bar", id: "switch.sonoff_100141aa85", type: "light", visKey: "bar" },
  { label: "Couloir", id: "switch.sonoff_100095367e", type: "light", visKey: "couloir" },
  { label: "Dressing", id: "switch.sonoff_100169d7cd", type: "light", visKey: "dressing" },
  { label: "Terrasse", id: "switch.sonoff_10013b29e3_1", type: "spa", visKey: "terrasse" },
  { label: "Fontaine", id: "switch.sonoff_10013b29e3_2", type: "spa", visKey: "fontaine" },
  { label: "Bulle", id: "switch.sonoff_10013b29e3_4", type: "spa", visKey: "bulle" },
];

export const ENTITY_IDS = ALL_DEVICES.map((d) => d.id);

export const DEFAULT_VISIBILITY = {
  salon: true,
  chambre: true,
  bar: true,
  couloir: true,
  dressing: true,
  terrasse: true,
  fontaine: true,
  bulle: true,
  videoprojecteur: true,
  ambilight: true,
  ambiances: true,
};

const ICONS = {
  terrasse: <LanternIcon />,
  fontaine: <FountainIcon />,
  bulle: <BubblesIcon />,
};

export const deviceIcon = (visKey) => ICONS[visKey] || <BulbIcon />;
